module.exports = __webpack_public_path__ + "static/img/map.61cb81c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/map.png
// module id = 4AZj
// module chunks = 0